import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Flags } from 'react-feature-flags'
import ItemDetail from './ItemDetail'
import CheckIcon from '../../../img/icon-check.svg'
import QuestionIcon from '../../../img/icon-question.svg'
import CloseIcon from '../../../img/icon-close-circle.svg'
import SVGWrapper from '../SVGWrapper'

const Details = ({ items, active, setActive, setDialog, showFeedback }) => {
    const scrollRef = useRef(null)

    return (
        <div className="details">
            <div className={`feedback ${showFeedback ? 'show' : ''}`}>
                <h4 className="title">Thank you for using the Site Check tool!</h4>
                <div className="content">
                    <p>
                        Please take a brief moment to leave some feedback about your experience using this tool, so we
                        can make it even better.
                    </p>
                    <button onClick={() => setDialog('feedback')}>Leave Feedback</button>
                </div>
            </div>

            <div className="disclaimer">
                <strong>Legal Disclaimer:</strong> The following report is provided as a public service, for
                informational purposes only. This report should not be construed as legal advice. Users of this report
                should independently verify its determinations prior to taking any action under the California
                Environmental Quality Act (CEQA) or any other law. The State of California makes no warranties as to
                accuracy of the underlying data.
            </div>
            <div
                className="scrollable-area"
                ref={scrollRef}
                onScroll={() => {
                    const children = Array.from(scrollRef.current.getElementsByClassName('item-detail'))
                    const topElement = children
                        .reverse()
                        .find(
                            child => child.offsetTop - scrollRef.current.scrollTop < scrollRef.current.clientHeight / 2
                        )

                    if (topElement && topElement.id !== active) {
                        setActive(topElement.id)
                    }
                }}
            >
                <h5 className="title is-5">Legend</h5>

                <p>
                    <span className="svg-icon svg-primary-primary svg-secondary-white mr-1" aria-hidden>
                        <CheckIcon width={20} height={20} />
                    </span>
                    A check mark means the tool determined the parcel met the spatial requirements for a CEQA provision.
                </p>
                <p>
                    <span className="svg-icon svg-primary-accent svg-secondary-white mr-1" aria-hidden>
                        <QuestionIcon width={20} height={20} />
                    </span>
                    A question mark indicates (1) the spatial requirements may have been met but must be further
                    verified by the user or (2) that there are no spatial requirements for that provision.
                </p>
                <p>
                    <span className="svg-icon svg-primary-danger-light svg-secondary-white mr-1">
                        <SVGWrapper title="X">
                            <CloseIcon width={20} height={20} />
                        </SVGWrapper>
                    </span>
                    An "x" in a circle means the tool determined that the site did not meet the CEQA spatial
                    requirements.
                </p>
                {items.map(item => (
                    <ItemDetail item={item} key={item.id} />
                ))}
            </div>
        </div>
    )
}

Details.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired
}

export default Details
